import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography} from 'views/components';
import {InfoOutlined} from 'views/icons';
import {MarkdownViewer, Translate} from 'views/module';

import CardPaper from './CardPaper';

const DescriptionCard = (props) => {
  const {description} = props;

  return (
    <CardPaper>
      <Stack direction="row" spacing={1} alignItems="center" sx={{mb: 1}}>
        <InfoOutlined fontSize="small" />
        <Typography variant="body2" sx={{fontWeight: 700}}>
          <Translate expression='jobDetail.Description' />
        </Typography>
      </Stack>

      <MarkdownViewer
        value={description.long.blob}
        style={{variant: 'body2', color: 'text.secondary', lineHeight: 1.6}}
      />
    </CardPaper>
  );
};

DescriptionCard.propTypes = {
  description: PropTypes.object.isRequired,
};

export default DescriptionCard;
